import { Injectable } from '@angular/core';
import { AuthMirrorService } from '@core/services/core/auth/auth-mirror.service';
import { MMobileHelperService } from '@core/services/core/mmobile-helper.service';
import { PolicyBaseType } from '@models/policy';
import { CARDS_LOCAL_CONFIG_BUSINESSES, ClientAreaCardRemoteConfig } from '@models/products';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientAreaConfigService {

  constructor(
    private mmobileHelper: MMobileHelperService,
    private authMirrorService: AuthMirrorService
  ) { }

  getCardsLocalConfig() {
    return this.authMirrorService.authService.checkUserIsCompany() ? CARDS_LOCAL_CONFIG_BUSINESSES : [];
  }

  getCardsRemoteConfig() {
    const cards: {
      [cardType: string]: {
        order: number,
        name: string,
        groupingName: string,
        minNumberSearchBarPolicies: number,
        ro: {
          entityCode: string,
          groupingCode: string
        },
        policyBaseTypes: PolicyBaseType[]
      }
    } = this.mmobileHelper.getCustomConfigData(
      'CLIENT_AREA_CARDS_CONFIG',
      this.authMirrorService.authService.checkUserIsCompany() ? 'businesses' : 'particulars',
      'cards'
    );
    if (!cards) {
      return of([] as ClientAreaCardRemoteConfig[]);
    }
    const cardTypes = Object.keys(cards);
    const cardConfigs: ClientAreaCardRemoteConfig[] = cardTypes.map(cardType => {
      const card = cards[cardType];
      return {
        cardType,
        order: card.order,
        policyCardName: card.name,
        groupingName: card.groupingName,
        minNumberSearchBarPolicies: card.minNumberSearchBarPolicies,
        ro: card.ro,
        policyBaseTypes: card.policyBaseTypes
      };
    });
    return of(cardConfigs);
  }
}
